import _ from 'lodash'
import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'

import { useRequestHandler } from '@/hooks/useRequestHandler'

import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import {
  saveMesures,
  selectConsultationById,
  selectConsultationCreateRequestTracker,
  selectConsultationUpdateRequestTracker,
  sendMesures,
  updateConsultation,
} from '@/redux/reducers/consultation.reducer'

import Mesures, { MesuresProps } from '../components/Mesures'
import MedconnectDevicesDialogContainer from './MedconnectDevicesDialogContainer'
import CommentField from '../components/CommentField'

type PC300MesuresProps = {
  consultationId?: string
}

export function PC300Mesures(props: PC300MesuresProps) {
  const { consultationId } = props
  // const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()

  // const [status, setPC300Status] = useState<boolean>(false)

  const [medconnectDevicesOpen, setMedconnectDevicesOpen] = useState<boolean>(false)

  const authUser = useAppSelector(selectAuthUser)
  const consultation = useAppSelector((state) => (consultationId ? selectConsultationById(state, consultationId) : undefined))

  const mesures = useMemo(() => _.sortBy(consultation?.mesures, 'order'), [consultation])


  const updateConsultationRequestHandler = useRequestHandler({
    onSuccess: () => {
      enqueueSnackbar(t('notification.consultation.update.success'), { variant: 'success' })
    },
    onError: () => enqueueSnackbar(t('notification.consultation.update.error'), { variant: 'error' }),
    requestTrackerSelector: selectConsultationUpdateRequestTracker,
  })

  const saveMesuresRequestHandler = useRequestHandler({
    onSuccess: () => enqueueSnackbar(t('notification.consultation.createMesuresCSV.success'), { variant: 'success' }),
    onError: () => enqueueSnackbar(t('notification.consultation.createMesuresCSV.error'), { variant: 'error' }),
    requestTrackerSelector: selectConsultationCreateRequestTracker,
  })

  const handleUpdateComment = (comment: string) => {
    if (consultationId) updateConsultationRequestHandler.dispatch(updateConsultation(consultationId, { commentaire: comment }))
  }

  const handleUpdateMesures = (mesures: MesuresProps['mesures']) => {
    if (consultationId) updateConsultationRequestHandler.dispatch(sendMesures(consultationId, mesures))
  }

  const handleSaveMesures = (csv: string) => {
    if (consultationId) saveMesuresRequestHandler.dispatch(saveMesures(consultationId, csv))
  }

  const handleOpenDevices = async () => {
    if (consultationId) setMedconnectDevicesOpen(true)
  }

  const handleClose = () => {
    setMedconnectDevicesOpen(false)
  }

  return (
    <>
      <Mesures
        mesures={mesures}
        pcStatus={false}
        onMesuresChange={handleUpdateMesures}
        onMesuresSave={handleSaveMesures}
        onOpenDevices={handleOpenDevices}
        readOnly={false}
      />
      <CommentField
        comment={consultation?.commentaire || ''}
        onCommentChange={handleUpdateComment}
        readOnly={false}
      />
      {consultationId && <MedconnectDevicesDialogContainer open={medconnectDevicesOpen} onClose={handleClose} consultationId={consultationId} />}
    </>
  )
}

export default PC300Mesures
